import { MapLocation } from './domain/models/map.models';

export function determineModeIconUseCase(
    location: MapLocation,
    shouldVerifyHighVolumeShop = false
): string {
    if (location.isHighVolumeShop && shouldVerifyHighVolumeShop) {
        return 'disabled';
    }
    return location.disabled ? 'used' : 'unused';
}
